import { useEffect, useState } from 'react';

/**
 * Tracks navigator.onLine. Spec wording for the indicator:
 *   true  → "Connected"
 *   false → "No network"
 *
 * navigator.onLine is a coarse signal (the OS-level guess); the shell uses it
 * as a baseline and the future sync-diagnostics feature will refine with real
 * fetch-result heuristics.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  );
  useEffect(() => {
    function on() { setOnline(true); }
    function off() { setOnline(false); }
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}
